import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, } from "../../utils/const/estilos-const";
import "../../style/style-cargando.css";
import {
    QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import cargandoCard from "../../components/cargando-card";
import SwitchComponent from "../../components/switch";
import Select from "react-select";
import { obtenerListaCorreos } from "../../api/correo";
import { TRUE } from "../../utils/const/bool-const";
import { obtenerListaTelefono } from "../../api/api-telefono";
import { crearAlertaChecklist, modificarAlertaChecklist, obtenerAlertaChecklist } from "../../api/alerta-checklist";
import ModalMessage from "../../components/modal-message";
import { useTranslation } from "react-i18next";


export default function AlertasPage() {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [titulo, setTitulo] = useState("");
    const [checklistSelected, setChecklistSelected] = useState({});
    const [infoAlertas, setInfoAlertas] = useState(null);
    const [isSwitchOnEnviarCorreo, setIsSwitchOnEnviarCorreo] = useState(false);
    const [isSwitchOnEnviarMensajeWhatsapp, setIsSwitchOnEnviarMensajeWhatsapp] = useState(false);
    const [listaCorreos, setListaCorreos] = useState([]);
    const [correosSelected, setCorreosSelected] = useState(null);
    const [listaTelefonos, setListaTelefonos] = useState([]);
    const [telefonosSelected, setTelefonosSelected] = useState(null);

    const [isOpenModalMessage, setIsOpenModalMessage] = useState(false);
    const [messageModal, setMessageModal] = useState("");

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            if (data !== undefined && data !== null) {
                setChecklistSelected(data);
                // setTitulo(data.titulo);

                const infoAlertas = await obtenerAlertaChecklist({ idChecklist: data.idChecklist });

                // console.log('infoAlertas');
                // console.log(infoAlertas);
                if (infoAlertas !== null) {
                    setInfoAlertas(infoAlertas);
                    if (infoAlertas.enviarCorreo === TRUE) {
                        setIsSwitchOnEnviarCorreo(true);
                    }
                    if (infoAlertas.enviarWhatsapp === TRUE) {
                        setIsSwitchOnEnviarMensajeWhatsapp(true);
                    }
                    const correos = JSON.parse(infoAlertas.listaCorreos);
                    const telefonos = JSON.parse(infoAlertas.listaTelefonos);
                    setCorreosSelected(correos);
                    setTelefonosSelected(telefonos);
                }

            }
            const listCorreos = await obtenerListaCorreos(true);
            setListaCorreos(listCorreos);

            const listaTelefonos = await obtenerListaTelefono(true);
            setListaTelefonos(listaTelefonos);

            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const handleCancelClick = () => {
        history.goBack();
    };

    const handleSaveClick = async () => {
        // console.log('handleSaveClick');
        // lógica para guardar los cambios
        // console.log('infoAlertas');
        // console.log(infoAlertas);
        // console.log('checklistSelected');
        // console.log(checklistSelected);
        let objEnviar = {};
        objEnviar.id = infoAlertas?.id;
        objEnviar.idChecklist = checklistSelected.idChecklist;
        objEnviar.enviarCorreo = isSwitchOnEnviarCorreo;
        objEnviar.enviarWhatsapp = isSwitchOnEnviarMensajeWhatsapp;
        objEnviar.listaCorreos = correosSelected;
        objEnviar.listaTelefonos = telefonosSelected;
        if (infoAlertas === null) {
            // console.log('crear correo');
            const creado = await crearAlertaChecklist(objEnviar);
            // console.log('creado');
            // console.log(creado);
            if (creado === true) {
                alert(t('alert_procesado_correctamente'));
                handleCancelClick();
            }
            if (creado === false) {
                alert(t('alert_no_se_pudo_procesar'));
            }
        }
        if (infoAlertas !== null) {
            // console.log('actualizar correo');
            const modificado = await modificarAlertaChecklist(objEnviar);
            // console.log('modificado');
            // console.log(modificado);
            if (modificado === true) {
                alert(t('alert_procesado_correctamente'));
                handleCancelClick();
            }
            if (modificado === false) {
                alert(t('alert_no_se_pudo_procesar'));
            }
        }
    };

    const toggleSwitchEnviarCorreo = () => {
        if (!isSwitchOnEnviarCorreo === false) {
            setCorreosSelected(null);
        }
        setIsSwitchOnEnviarCorreo(!isSwitchOnEnviarCorreo);
    };

    const toggleSwitchEnviarMensajeWhatsapp = () => {
        if (!isSwitchOnEnviarMensajeWhatsapp === false) {
            setListaTelefonos(null);
        }
        setIsSwitchOnEnviarMensajeWhatsapp(!isSwitchOnEnviarMensajeWhatsapp);
    };

    const render = () => {
        // console.log('render correo');
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="min-h-screen bg-gray-100 flex flex-col  py-12 sm:px-6 lg:px-8">
                    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                        <div className="mt-6 bg-white py-6 px-4 shadow-md rounded-lg sm:px-10">
                            <div className="space-y-6">
                                <div>
                                    <label
                                        htmlFor="nombre"
                                        className="block text-md font-medium text-gray-700 flex items-center cursor-pointer"
                                        onClick={() => {
                                            setMessageModal("Esta Alerta, se enviara a los correos y/o telefonos seleccionados. Si y solo si, se realizo este checklist");
                                            setIsOpenModalMessage(true);
                                        }}
                                    >
                                        {t('titulo_alertas')} - {checklistSelected.nombre}
                                        <QuestionMarkCircleIcon className="w-5 h-5 ml-2" />
                                    </label>
                                </div>

                                <div>
                                    <label
                                        htmlFor="nombre"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t('label_enviar_correo')}
                                    </label>
                                    <div className="flex justify-start pt-2 ">
                                        <SwitchComponent isOn={isSwitchOnEnviarCorreo} handleToggle={toggleSwitchEnviarCorreo} />
                                        <p className="ml-4" >{isSwitchOnEnviarCorreo ? t('label_si') : t('label_no')}</p>
                                    </div>
                                </div>

                                {isSwitchOnEnviarCorreo === true &&
                                    <div>
                                        <Select
                                            options={listaCorreos}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={correosSelected}
                                            onChange={(e) => {
                                                setCorreosSelected(e);
                                            }}
                                            placeholder={t('label_seleccione_correos')}
                                        />
                                    </div>
                                }

                                <div>
                                    <label
                                        htmlFor="nombre"
                                        className="block text-sm font-medium text-gray-700"
                                    >
                                        {t('label_enviar_mensaje_via_whatsapp')}
                                    </label>
                                    <div className="flex justify-start pt-2 ">
                                        <SwitchComponent isOn={isSwitchOnEnviarMensajeWhatsapp} handleToggle={toggleSwitchEnviarMensajeWhatsapp} />
                                        <p className="ml-4" >{isSwitchOnEnviarMensajeWhatsapp ? t('label_si') : t('label_no')}</p>
                                    </div>
                                </div>

                                {isSwitchOnEnviarMensajeWhatsapp === true &&
                                    <div>
                                        <Select
                                            options={listaTelefonos}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={telefonosSelected}
                                            onChange={(e) => {
                                                setTelefonosSelected(e);
                                            }}
                                            placeholder={t('label_seleccione_telefonos')}
                                        />
                                    </div>
                                }

                                <div className="flex justify-end">
                                    <div
                                        style={{
                                            justifyContent: 'space-between',
                                            display: 'flex',
                                            width: '100%'
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className={ESTILO_BOTON_GENERAL_CANCELAR}
                                            onClick={handleCancelClick}
                                        >
                                            {t('btn_cancelar')}
                                        </button>
                                        <button
                                            type="button"
                                            className={ESTILO_BOTON_GENERAL_ACEPTAR}
                                            onClick={handleSaveClick}
                                        >
                                            {t('btn_aceptar')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalMessage
                        isOpen={isOpenModalMessage}
                        onClose={() => setIsOpenModalMessage(false)}
                        message={messageModal}
                    />
                </div>
            );
        } catch (err) {
            console.log('Alertas render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
